import { FC } from "react";
import { cx } from "shared/utils";

export const NewTag: FC<{ className?: string }> = ({ className }) => (
  <span
    className={cx(
      "inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-bold uppercase leading-none tracking-wide text-primary-500 bg-primary-20",
      className
    )}
  >
    New
  </span>
);
